import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "updateProfileForm",
    ref: "updateProfileForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { style: {"max-height":"320px","overflow-y":"scroll","overflow-x":"hidden","flex-grow":"1"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.userInfo['email'],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInfo['email']) = $event)),
            "field-id": "emailField",
            label: _ctx.i18n.t('fields.emailaddress'),
            rules: [_ctx.rules.email],
            type: "email",
            autocomplete: "username",
            icon: "mdi-email-outline",
            readonly: true
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.userInfo['phoneNumber'],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInfo['phoneNumber']) = $event)),
            "field-id": "phoneNumberField",
            label: _ctx.i18n.t('fields.phonenumber'),
            rules: [_ctx.rules.phone_number],
            type: "tel",
            icon: "mdi-phone-outline",
            readonly: !_ctx.edit
          }, null, 8, ["modelValue", "label", "rules", "readonly"]),
          (_ctx.edit)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_PolteqTextField, {
                        modelValue: _ctx.userInfo['givenName'],
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userInfo['givenName']) = $event)),
                        "field-id": "firstNameField",
                        label: _ctx.i18n.t('fields.firstName'),
                        rules: [_ctx.rules.required],
                        type: "text",
                        icon: "mdi-account-outline",
                        readonly: !_ctx.edit
                      }, null, 8, ["modelValue", "label", "rules", "readonly"]),
                      _createVNode(_component_PolteqTextField, {
                        modelValue: _ctx.userInfo['familyName'],
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userInfo['familyName']) = $event)),
                        "field-id": "lastNameField",
                        label: _ctx.i18n.t('fields.lastName'),
                        rules: [_ctx.rules.required],
                        type: "text",
                        readonly: !_ctx.edit,
                        style: {"margin-left":"4px"}
                      }, null, 8, ["modelValue", "label", "rules", "readonly"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.userInfo['address'].street !== '' || _ctx.edit)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.edit)
                  ? (_openBlock(), _createBlock(_component_v_textarea, {
                      key: 0,
                      class: "ma-10 pa-10",
                      rows: "3",
                      "prepend-icon": "mdi-home-city-outline",
                      label: _ctx.i18n.t('fields.address'),
                      variant: "solo",
                      density: "comfortable",
                      "no-resize": "",
                      readonly: "",
                      flat: "",
                      "model-value": 
              _ctx.userInfo['address'].street +
                ' ' +
                _ctx.userInfo['address'].houseNumber +
                ' ' +
                _ctx.userInfo['address'].houseNumberAddition +
                '\n' +
                _ctx.userInfo['address'].postCode +
                ' ' +
                _ctx.userInfo['address'].city +
                '\n' +
                _ctx.userInfo['address'].country
            
                    }, null, 8, ["label", "model-value"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_PolteqTextField, {
                        modelValue: _ctx.userInfo['address'].street,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInfo['address'].street) = $event)),
                        "field-id": "streetField",
                        label: _ctx.i18n.t('fields.street'),
                        type: "text",
                        icon: "mdi-map-marker-outline",
                        readonly: !_ctx.edit
                      }, null, 8, ["modelValue", "label", "readonly"]),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_PolteqTextField, {
                                modelValue: _ctx.userInfo['address'].houseNumber,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userInfo['address'].houseNumber) = $event)),
                                "field-id": "houseNumberField",
                                label: _ctx.i18n.t('fields.housenumber'),
                                type: "text",
                                icon: "mdi-map-marker-outline",
                                readonly: !_ctx.edit
                              }, null, 8, ["modelValue", "label", "readonly"]),
                              _createVNode(_component_PolteqTextField, {
                                modelValue: _ctx.userInfo['address'].houseNumberAddition,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userInfo['address'].houseNumberAddition) = $event)),
                                "field-id": "houseNumberAdditionField",
                                label: _ctx.i18n.t('fields.housenumberaddition'),
                                type: "text",
                                readonly: !_ctx.edit,
                                style: {"margin-left":"4px","border":"1px"}
                              }, null, 8, ["modelValue", "label", "readonly"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_PolteqTextField, {
                                modelValue: _ctx.userInfo['address'].postCode,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userInfo['address'].postCode) = $event)),
                                "field-id": "postCodeField",
                                label: _ctx.i18n.t('fields.postCode'),
                                type: "text",
                                icon: "mdi-map-marker-outline",
                                readonly: !_ctx.edit
                              }, null, 8, ["modelValue", "label", "readonly"]),
                              _createVNode(_component_PolteqTextField, {
                                modelValue: _ctx.userInfo['address'].city,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userInfo['address'].city) = $event)),
                                "field-id": "cityField",
                                label: _ctx.i18n.t('fields.city'),
                                type: "text",
                                readonly: !_ctx.edit,
                                style: {"margin-left":"4px"}
                              }, null, 8, ["modelValue", "label", "readonly"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.userInfo['address'].country,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userInfo['address'].country) = $event)),
                        variant: "solo",
                        "prepend-icon": "mdi-map-marker-outline",
                        flat: "",
                        density: "comfortable",
                        label: _ctx.i18n.t('fields.country'),
                        items: _ctx.countryNames,
                        "auto-select-first": "",
                        "hide-selected": ""
                      }, null, 8, ["modelValue", "label", "items"])
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.edit)
        ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0,
            style: {"text-align":"end"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PolteqButton, {
                "button-id": "editProfileButton",
                icon: "mdi-account-edit-outline",
                "button-text": _ctx.i18n.t('texts.editprofile'),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.edit = true))
              }, null, 8, ["button-text"]),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_PolteqButton, {
                "button-id": "changePasswordButton",
                icon: "mdi-account-key-outline",
                "button-text": _ctx.i18n.t('texts.editpassword'),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.CHANGE_PASSWORD)))
              }, null, 8, ["button-text"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_card_text, {
            key: 1,
            style: {"text-align":"end"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PolteqButton, {
                "button-id": "saveProfileButton",
                icon: "mdi-account-check-outline",
                "button-text": _ctx.i18n.t('texts.saveprofile'),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveProfile(_ctx.userInfo)))
              }, null, 8, ["button-text"]),
              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_PolteqButton, {
                "button-id": "cancelEditButton",
                icon: "mdi-account-cancel-outline",
                "button-text": _ctx.i18n.t('texts.cancel'),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancelEdit()))
              }, null, 8, ["button-text"])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 512))
}